import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { MoreNewsItem }
from '@fuww/components/src/Articles/Sections/MoreNews';
import InView from '../../../InView';
import loading from '../../../../lib/loading';

const MoreNewsList = dynamic(() => import(
  '../../NewsList/Categories/MoreNews'
), {
  ssr: false,
  loading,
});

const MoreNewsListWhenInView = (properties) => (
  <InView>
    <MoreNewsList
      {...properties}
    />
  </InView>
);

const MoreNewsListBlock = ({ variables, offset }) => (
  <>
    <MoreNewsItem
      borderRight="1px solid var(--grey-light)"
      className="fu-read-more"
      padding="0 24px 0 0"
    >
      <MoreNewsListWhenInView
        showCategory
        noBorderFirstItem
        categoryHeadline={false}
        variables={variables}
        offset={offset}
        limit={3}
      />
    </MoreNewsItem>
    <MoreNewsItem
      borderRight="1px solid var(--grey-light)"
      padding="0 24px 0 0"
    >
      <MoreNewsListWhenInView
        showCategory
        noBorderFirstItem
        categoryHeadline={false}
        variables={variables}
        offset={offset + 3}
        limit={3}
      />
    </MoreNewsItem>
    <MoreNewsItem
      borderRight="1px solid var(--grey-light)"
      padding="0 24px 0 0"
    >
      <MoreNewsListWhenInView
        noBorderFirstItem
        categoryHeadline={false}
        variables={variables}
        offset={offset + 6}
        limit={4}
      />
    </MoreNewsItem>
    <MoreNewsItem>
      <MoreNewsListWhenInView
        categoryHeadline={false}
        noBorderFirstItem
        variables={variables}
        offset={offset + 10}
        limit={4}
      />
    </MoreNewsItem>
  </>
);

MoreNewsListBlock.cardinality = 14;

MoreNewsListBlock.propTypes = {
  variables: PropTypes.shape({}),
  offset: PropTypes.number,
};

MoreNewsListBlock.defaultProps = {
  variables: null,
  offset: 0,
};

export default MoreNewsListBlock;
